const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Deltakende virksomheter krediteres kickback-gebyr på grunnlag av innsendte salgstall.",
};

export default {
  messages,
};
